import { Button } from '@shared/components/shadcn';
import { Circle3 } from '@shared/icons';
import { twMerge } from '@shared/themes';
import { FRONTIFY_URL } from '@shared/utils';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';

/**
 * Offer banner component for the home page
 * @param {Object} props - The component props
 * @param {string} props.ctaLink - The link to the cta
 * @param {string} props.namespace - The namespace for the translations
 * @returns {JSX.Element} The HomePageOfferBanner component
 */
const HomePageOfferBanner = ({ ctaLink, namespace, className }: { ctaLink: string; namespace: string; className?: string }) => {
  const t = useTranslations(namespace);

  return (
    <div
      data-testid="offer-banner"
      data-track-container="Discover Offers"
      data-track-name="View Offers"
      className={twMerge(
        'relative flex h-48 md:h-56 lg:h-81.25 p-5 md:p-0 items-center rounded-lg bg-container-accent dark:bg-container-accent-inverse gap-8 overflow-hidden',
        className
      )}
    >
      <div className="relative hidden h-full md:block md:w-1/2">
        <Image src={`${FRONTIFY_URL}QHWkPnFX4D6uw1KPYPC3.png`} alt="Offers Banner" fill className="object-cover" />
      </div>

      <div className="relative flex flex-col items-start justify-center gap-5 text-foreground-inverse dark:text-foreground">
        <h3 className=" xs:heading-4 lg:heading-3 lg:w-94 w-75 text-start">
          {t.rich('title', {
            highlighted: text => <span className="text-accent-yellow">{text}</span>,
          })}
        </h3>
        <Button asChild variant="secondary" size="m" className="light" data-track-name="Browse">
          <Link href={ctaLink}>{t('cta')}</Link>
        </Button>
      </div>

      <Circle3 className="absolute z-0 -bottom-10 -right-25 md:right-0 size-60 md:hidden" />
    </div>
  );
};

export { HomePageOfferBanner };
